import { render, staticRenderFns } from "./EvidenceList.vue?vue&type=template&id=23d98931&scoped=true"
import script from "./EvidenceList.vue?vue&type=script&lang=js"
export * from "./EvidenceList.vue?vue&type=script&lang=js"
import style0 from "./EvidenceList.vue?vue&type=style&index=0&id=23d98931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d98931",
  null
  
)

export default component.exports